<div class="l-mybooking__option-item search-flight__erea-size">
  <!-- [SP版] -->
  <ng-container *ngIf="isSP; else notSP">
    <!-- [タイトル] -->
    <div class="p-keep-my-fare__title search-flight__plan-zero-size">
      <span class="c-flight-info01__title" [innerHTML]="'label.planZero' | staticMsg"></span>
    </div>
    <!-- [//タイトル] -->

    <!-- [説明文言] -->
    <div class="p-sky-coins__use-input search-flight__plan-zero-size">
      <p [innerHTML]="'label.planZeroExplain' | staticMsg"></p>
    </div>
    <!-- [//説明文言] -->

    <!-- [空席照会ボタン] -->
    <div class="search-flight__search-flight-button-center">
      <button
        id="plan-list-search-flight-bitton-1"
        class="c-btn-primary c-btn-primary--s search-flight__search-flight-button"
      >
        <span
          class="c-btn-primary__text"
          [innerHTML]="'label.startSearch' | staticMsg"
          (click)="goToSearchFlight()"
        ></span>
      </button>
    </div>
    <!-- [//空席照会ボタン] -->
  </ng-container>
  <!-- [//SP版] -->

  <!-- [PC、TAB版] -->
  <ng-template #notSP>
    <table class="p-family-miles__table">
      <!-- [タイトル] -->
      <tr>
        <div class="p-keep-my-fare__title search-flight__plan-zero-size">
          <span class="c-flight-info01__title" [innerHTML]="'label.planZero' | staticMsg"></span>
        </div>
      </tr>
      <!-- [//タイトル] -->

      <tr>
        <!-- [説明文言] -->
        <td>
          <div class="p-sky-coins__use-input search-flight__plan-zero-size">
            <p [innerHTML]="'label.planZeroExplain' | staticMsg"></p>
          </div>
        </td>
        <!-- [//説明文言] -->

        <!-- [空席照会ボタン] -->
        <td>
          <div class="p-select-flight-panel02__move-btn">
            <button
              id="plan-list-search-flight-bitton-2"
              class="c-btn-primary c-btn-primary--s search-flight__search-flight-button"
            >
              <span
                class="c-btn-primary__text"
                [innerHTML]="'label.startSearch' | staticMsg"
                (click)="goToSearchFlight()"
              ></span>
            </button>
          </div>
        </td>
        <!-- [//空席照会ボタン] -->
      </tr>
    </table>
  </ng-template>
  <!-- [//PC、TAB版] -->
</div>
